import { useCallback, useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllQuotations, deleteQuotation,fetchPDF } from "../../services/QuotationServices";
import { getAllBank } from "../../services/BankService";
import { displayError } from "../../helpers";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { buildQuotationQueryParams } from "../../utils/listViewDateRanges";
import { getDefaultListViewConfig } from "../../config/listViewSettingsConfig";
import { bootstrapListViewLoad } from "../../utils/listViewBootstrap";
import ListFormPageHeader from "../../components/ListFormPageHeader";
import ListPageGradientSummary from "../../components/ListPageGradientSummary";
import { buildGradientCard, formatQty, formatAmount, sumField, splitRecordsByStatus, buildCancelledSummaryCard } from "../../utils/listSummaryUtils";
import moment from "moment";


function QuotationTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true);
    const todayDateLabel = moment().format('DD-MM-YYYY');

    const { active: activeRecords, cancelled: cancelledRecords } = useMemo(
        () => splitRecordsByStatus(data.records),
        [data.records],
    );

    const highlightCard = useMemo(() => {
        const todayCount = activeRecords.filter((row) => row.quotation_date === todayDateLabel).length;
        return buildGradientCard('Today Quote', todayCount, 'today');
    }, [activeRecords, todayDateLabel]);

    const summaryCards = useMemo(() => {
        const cards = [
            buildGradientCard('Total', activeRecords.length, 'blue'),
            buildGradientCard('Total Qty', formatQty(sumField(activeRecords, 'quantity')), 'purple'),
            buildGradientCard('Total Amount', formatAmount(sumField(activeRecords, 'amount')), 'teal'),
        ];
        const cancelledCard = buildCancelledSummaryCard(cancelledRecords, {
            valueField: 'quantity',
            entityLabel: 'quote cancelled',
        });
        if (cancelledCard) cards.push(cancelledCard);
        return cards;
    }, [activeRecords, cancelledRecords]);

    const cancelledPopup = useMemo(() => ({
        title: `Cancelled Quotations (${cancelledRecords.length})`,
        emptyMessage: 'No cancelled quotations in the current list.',
        columns: [
            { key: 'quotation_no', label: 'Quotation No', align: 'center' },
            { key: 'quotation_date', label: 'Date', align: 'center' },
            { key: 'customer_id', label: 'Customer', align: 'left' },
            { key: 'project_name', label: 'Project', align: 'left' },
            { key: 'quantity', label: 'Qty', align: 'right' },
            { key: 'amount', label: 'Amount', align: 'right' },
        ],
        getRows: () => cancelledRecords,
        mapRow: (row) => ({
            quotation_no: row.quotation_no,
            quotation_date: row.quotation_date,
            customer_id: row.customer_id,
            project_name: row.project_name,
            quantity: formatQty(row.quantity),
            amount: formatAmount(row.amount),
        }),
        footerRowBuilder: (rows) => ({
            quotation_no: 'Total',
            quotation_date: '',
            customer_id: '',
            project_name: `${rows.length} Quote`,
            quantity: formatQty(sumField(rows, 'quantity')),
            amount: formatAmount(sumField(rows, 'amount')),
        }),
    }), [cancelledRecords]);

    const columns = useMemo(
        () => [
            {
                fieldName: "quotation_no",
                headerName: 'Quotation No.',
                size: 180,
                minSize: 160,
            },
            {
                fieldName: 'company_id',
                headerName: 'Company Name',
                size: 140,
                minSize: 120,
            },
            {
                fieldName: "quotation_date",
                headerName: 'Date',
                size: 110,
                minSize: 100,
            },
            {
                fieldName: 'customer_id',
                headerName: 'Customer Name',
                size: 200,
                minSize: 160,
            },
            {
                fieldName: 'project_name',
                headerName: 'Project',
                size: 160,
                minSize: 120,
            },
            {
                fieldName: 'product_id',
                headerName: 'Grade',
                size: 100,
                minSize: 80,
            },
            {
                fieldName: "quantity",
                headerName: 'Qty',
                size: 80,
                minSize: 70,
                align: 'right',
            },
            {
                fieldName: "rate",
                headerName: 'Rate',
                size: 100,
                minSize: 80,
                align: 'right',
            },
            {
                fieldName: "amount",
                headerName: 'Amount',
                size: 110,
                minSize: 90,
                align: 'right',
            },
            {
                fieldName: 'tax',
                headerName: 'Tax',
                size: 120,
                minSize: 100,
            },
            {
                fieldName: 'concrete_structure',
                headerName: 'Concrete Structure',
                size: 160,
                minSize: 140,
            },
            {
                fieldName: 'delivery_mode',
                headerName: 'Mode of Delivery',
                size: 150,
                minSize: 130,
            },
            {
                fieldName: 'salesrep_id',
                headerName: 'Marketing',
                size: 150,
                minSize: 120,
            },
            {
                fieldName: "status",
                headerName: 'Status',
                size: 100,
                minSize: 90,
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);

    const onEditQuotation = (quotationId, event) => {
       
       navigate(`/QuotationEdit/${quotationId}/`);
    };
    const onDeleteQuotation = (quotationId, event) => {

        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
            setIsLoading(true);
            deleteQuotation(cookies, quotationId); 
        console.log(`Quotation with id ${quotationId} deleted`);
            Swal.fire('Deleted Successfully!', '', 'success');
            setRefreshKey(oldKey => oldKey +1)
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(quotationcsv => {

                const csvRow = {
                    company_id: quotationcsv.company_id,
                    product_id:quotationcsv.product_id,
                    quotation_no:quotationcsv.quotation_no,
                    quotation_date:quotationcsv.quotation_date,
                    customer_id:quotationcsv.customer_id,
                    salesrep_id:quotationcsv.salesrep_id,
                    consignee_id:quotationcsv.consignee_id,    
                    //consignee_pro_id:quotationcsv.consignee_pro_id,            
                    quantity: quotationcsv.quantity, 
                    rate: quotationcsv.rate, 
                    amount: quotationcsv.amount, 
                    status:quotationcsv.status ? "active":"inactive" 
                }
                return csvRow;
                }));
    };

    const handlePrint = async (quotationId, event) => {
        if (event?.preventDefault) {
            event.preventDefault();
        }
        if (event?.stopPropagation) {
            event.stopPropagation();
        }

        const formatResult = await Swal.fire({
            title: 'Select PDF Format',
            text: 'Choose which quotation PDF layout to generate',
            input: 'radio',
            inputOptions: {
                simple: 'Simple',
                condensed: 'Condensed',
                detailed: 'Detailed',
            },
            inputValue: 'detailed',
            showCancelButton: true,
            confirmButtonText: 'Generate PDF',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            heightAuto: false,
            scrollbarPadding: false,
            didOpen: () => {
                const container = Swal.getContainer();
                if (container) {
                    container.style.zIndex = '30000';
                }
            },
            inputValidator: (value) => {
                if (!value) {
                    return 'Please select Simple, Condensed, or Detailed';
                }
                return undefined;
            },
        });

        if (!formatResult.isConfirmed || !formatResult.value) {
            return;
        }

        let bankId = null;
        try {
            const bankResponse = await getAllBank(cookies);
            const activeBanks = (bankResponse.bank_list || []).filter((bank) => bank.status);
            if (activeBanks.length > 1) {
                const bankOptions = activeBanks.reduce((acc, bank) => {
                    const labelParts = [
                        bank.name,
                        bank.bank_alias,
                        bank.account_no ? `A/c ${bank.account_no}` : '',
                    ].filter(Boolean);
                    acc[String(bank.id)] = labelParts.join(' - ');
                    return acc;
                }, {});
                const bankResult = await Swal.fire({
                    title: 'Select Bank for Document',
                    text: 'More than one bank found. Choose which bank account to show on the quotation.',
                    input: 'select',
                    inputOptions: bankOptions,
                    inputValue: String(activeBanks[0].id),
                    showCancelButton: true,
                    confirmButtonText: 'Generate PDF',
                    cancelButtonText: 'Cancel',
                    allowOutsideClick: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        if (container) {
                            container.style.zIndex = '30000';
                        }
                    },
                });
                if (!bankResult.isConfirmed) {
                    return;
                }
                bankId = bankResult.value;
            } else if (activeBanks.length === 1) {
                bankId = activeBanks[0].id;
            }
        } catch (error) {
            console.error(error);
        }

        setIsLoading(true);
        try {
            const response = await fetchPDF(cookies, quotationId, formatResult.value, bankId);
            openPdfResponse(response, {
                title: `Quotation (${formatResult.value})`,
                downloadFileName: `quotation_${formatResult.value}.pdf`,
            });
        } catch (error) {
            console.error(error);
            displayError(error, 'Custom print/export failed');
        } finally {
            setIsLoading(false);
        }
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Quotation',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(quotationpdf => ({

                company_id: quotationpdf.company_id,
                product_id:quotationpdf.product_id,
                quotation_no:quotationpdf.quotation_no,
                quotation_date:quotationpdf.quotation_date,
                customer_id:quotationpdf.customer_id,
                salesrep_id:quotationpdf.salesrep_id,
                consignee_id:quotationpdf.consignee_id,    
                //consignee_pro_id:quotationcsv.consignee_pro_id,            
                quantity: quotationpdf.quantity, 
                rate: quotationpdf.rate, 
                amount: quotationpdf.amount, 
                status:quotationpdf.status ? "active":"inactive"
            })),
            'quotation.pdf'
        );
    };

    const loadQuotationList = useCallback((config) => {
        if (!cookies.myToken) {
            setIsLoading(false);
            return Promise.resolve();
        }
        const activeConfig = config || getDefaultListViewConfig('quotation');
        setIsLoading(true);
        return getAllQuotations(cookies, {
            ...buildQuotationQueryParams(activeConfig),
            limit: 500,
        })
        .then( quotationList => {
            const tableData = (quotationList?.quotation_list || [])
            .map(quotation => ({
                id: quotation.id, 
                company_id: quotation.company.alias,
                product_id:quotation.product.name,
                quotation_no:(quotation.prefix+quotation.quotation_no),
                quotation_date:quotation.quotation_date,
                customer_id:quotation.customer.name,
                salesrep_id:quotation.customer.salesrep.name,
                consignee_id:quotation.consignee.name,
                quantity: quotation.quantity, 
                rate: quotation.rate, 
                amount: quotation.amount, 
                status:quotation.status ? "Active":"Cancelled",
                project_name:quotation.consignee.project_name,
                tax:quotation.tax.name,
                concrete_structure:quotation.concrete_structure.name,
                delivery_mode:quotation.delivery_mode.toUpperCase()
            }));

            setData({
                total: tableData.length,
                records: tableData
            });
        })
        .catch((error) => {
            setData({ total: 0, records: [] });
            displayError(error.response?.data ?? error.message, 'Failed to load quotations');
        })
        .finally(() => setIsLoading(false));
    }, [cookies]);

    const handleSettingsSaved = useCallback((config) => {
        loadQuotationList(config);
    }, [loadQuotationList]);

    useEffect(() => {
        if (!cookies.myToken) {
            setIsLoading(false);
            return undefined;
        }
        let cancelled = false;
        bootstrapListViewLoad({
            cookies,
            viewKey: 'quotation',
            loadFn: loadQuotationList,
            isCancelled: () => cancelled,
        });
        return () => { cancelled = true; };
    }, [cookies, cookies.myToken, loadQuotationList, refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
            <ListFormPageHeader
                module="MARKETING"
                title="List of Quotation"
                viewKey="quotation"
                onSettingsSaved={handleSettingsSaved}
                formLink="/Quotation"
                addNewLabel="New Quotation"
            />
            <ListPageGradientSummary
                highlightCard={highlightCard}
                cards={summaryCards}
                cancelledPopup={cancelledPopup}
            />
            <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Quotation'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditQuotation}
                            onRowDelete={onDeleteQuotation}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                            hideDelete={true}
                            onRowPrint={handlePrint}
                            hidePrint ={false}
                            compactColumns
                            wrapText
                        />
                </div>
                </div> 


            </div>
</div>

        
    );

}



export default QuotationTable;